import SearchUiDom from './SearchUiDom';
import AdvancedSearchUiDomEventHandler from './AdvancedSearchUiDomEventHandler';
import AdvancedSearchUiDomUpdater from './AdvancedSearchUiDomUpdater';
import { renderAdvancedSearch } from './AdvancedSearch';

/**
 * Advanced Search UI Controller constructor
 *
 * @param {object} messageBus  WH message bus
 *
 * @constructor
 */
function AdvancedSearchUiController(deps) {

    this.deps = deps || {};

    this.dom = new SearchUiDom();

    this.advancedSearchUiDomEventHander = new AdvancedSearchUiDomEventHandler(this.dom);
    this.advancedSearchUiDomUpdater = new AdvancedSearchUiDomUpdater(this.dom, deps);
    renderAdvancedSearch();
}

export default AdvancedSearchUiController;
